// extracted by mini-css-extract-plugin
module.exports = {"root":"az_Teb","text":"az_Ueb","pulse":"az_Veb","wave":"az_Web"};